$(function () {
    if (typeof flatpickr !== 'undefined') {
        flatpickr("#fromDate",{
            dateFormat:"M d, Y",
            minDate:"today",
            onChange:function(selectedDates,dateStr){
                toPicker.set("minDate",dateStr);
            }
        });

        const toPicker = flatpickr("#toDate",{
            dateFormat:"M d, Y",
            minDate:"today"
        });
    }
});
